<script setup>
import { useForm } from "@/form";
import UpdateAutomaticPagesSettingsForm from "./Partials/UpdateAutomaticPagesSettingsForm.vue";
import UpdateAutomaticPagesTemplateForm from "./Partials/UpdateAutomaticPagesTemplateForm.vue";
import Layout from "./Partials/Layout.vue";

const settings = await useForm().post("linking_automatic_pages_index");
</script>

<template>
    <Layout>
        <div class="flex flex-col flex-1 py-8 space-y-6 sm:px-6 lg:px-8">
            <UpdateAutomaticPagesSettingsForm :settings="settings" />
            <UpdateAutomaticPagesTemplateForm :settings="settings.template" />
        </div>
    </Layout>
</template>
